import LazyLoad from "vanilla-lazyload";
import { initializeMap } from "Functions/map";

import "Layouts/default";
import "Ui/slider";
import "Common/lightgallery";

const branchMapElem = document.querySelector(".js-branch-map");

if (branchMapElem) {
    window.mapLazyLoad = new LazyLoad({
        threshold: 125,
        elements_selector: ".js-branch-map",
        callback_enter: (el) => {
            initializeMap(
                ".js-branch-map",
                {
                    default: {
                        latitude: parseFloat(branchMapElem.dataset.latitude),
                        longitude: parseFloat(branchMapElem.dataset.longitude),
                        icon: branchMapElem.dataset.pin,
                    },
                },
                {
                    latitude: branchMapElem.dataset.latitude,
                    longitude: branchMapElem.dataset.longitude,
                    zoom: 14,
                }
            );
        },
    });
}
